import React from 'react';

import img from '../../assests/icons/start.png';

export default function StartIcon(props) {

    return (
        <img src={img} alt="" className="img-responsive Start-icon icon"/>
    );
}